import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button, Box } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import '../css/error.css';

const ErrorPage = () => {
  return (
    <Container className="error-container" maxWidth="md">
      <Box className="error-box" textAlign="center">
        <Box className="error-code">
          <Typography variant="h1" component="span">4</Typography>
          <SentimentDissatisfiedIcon className="error-icon" />
          <Typography variant="h1" component="span">4</Typography>
        </Box>
        <Typography variant="h5" className="error-message">
          Oops! The page you are looking for could not be found.
        </Typography>
        <Button 
          variant="contained" 
          component={Link} 
          to="/home" 
          className="error-button"
        >
          Go Back Home
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
